import { Logger } from '@cgs/shared';
import { Container } from '@cgs/wge';
import { SpinViewMachineListener } from './spin_view_machine_listener';
import { GameStateMachineStates } from '../../reels_engine/state_machine/game-state-machine-states';

export class FreeFallSpinViewMachineListener extends SpinViewMachineListener {
  constructor(container: Container) {
    super(container);
  }

  onStateEntered(slotState: string): void {
    switch (slotState) {
      case GameStateMachineStates.Collapse:
        this.viewController.disableSpinButton();
        break;
      default:
        Logger.Debug('call default onStateEntered: ' + slotState);
        super.onStateEntered(slotState);
    }
  }
}
